


import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'


import PositionBtn from "../../components/PositionBtn/PositionBtn";
export default {

components: { PositionBtn, Swiper, SwiperItem },
data() {

return {
hid: this.$route.query.hid,
scenicData: null, //景区所有数据
scenicMapObj: null, //地图实例
leLayer: null,
isleLayerShow: true, //瓦片是否展示
isLocation: false, //是否展示当前定位了
scenicBound: [], //电子围栏
isInLine: false, //是否在线路中
lines: [], //线路所有数据
activeLineIdx: -1, //选中的线路下标
activeLineSpotIdx: -1, //选中的线路的选中点的下标
polyline: null, //线路中的线
isNearListShow: false, //附近点列表是否展示
mapMinZoom:13,
mapMaxZoom:18,

isLineListShow: false, //是否展示线路列表

poiType: [],
activePoiTypeId: null, //选中展示的poi类别
scenicPoi: [],
parkPoi: [],
toiletPoi: [],
catePoi: [],
hotelPoi: [],
shopPoi: [],
servicePoi: [],
curMarkers: [], //当前地图中的点位
playing: false, //景点弹窗中音频播放状态
activeScenicPoiData: null, //点击景点的数据
myAudioSrc: null, //音频地址

swiperItemIndex: 0,

};
},

computed: {
activePoiTypeIndex() {
if (this.poiType == null) {
return null;
} else {
for (let i in this.poiType) {
if (this.poiType[i].id == this.activePoiTypeId) {
return i;
}
}
}
}, //当前选中的poi类型下标
},

watch: {},

methods: {

getScenicData() {
let that = this;
that.get({
url:
that.GLOBAL.BASE_URL + "/api/v1/map_view!GetSingleSecentWebs.action",
params: { hid: that.hid },
isShowLoading: true,
success: function (data) {
console.log(data);
that.scenicData = data.data.data.scenic;
document.title = data.data.data.scenic.name;

function getPoiList(Arr) {
let zoomRange =
parseInt(that.mapMaxZoom) - parseInt(that.mapMinZoom); 
for (let j = 0; j < zoomRange + 1; j++) {
let arr = [];
Arr.push(arr);
}
}

that.setPoiType(data.data.data.navTabs);
that.setPois(data.data.data.scenic.pointses);

that.setMap();

that.setLine(data.data.data.scenic.hotspotLinesList);
},
});
},

setMap() {
let that = this;

that.scenicMapObj = new AMap.Map("scenicMap", {
view: new AMap.View2D({

center: new AMap.LngLat(
that.scenicData.longitude,
that.scenicData.latitude
),
zoom: that.scenicData.min_zoom, //设置地图缩放级别
rotation: 0, //设置地图旋转角度
}),
resizeEnable: true,
zooms: [that.mapMinZoom, that.mapMaxZoom],
features: ["bg", "road", "building"],
lang: "zh_cn", //设置地图语言类型，默认：中文简体
});

for (let i in that.scenicData.polygons) {
that.scenicBound.push([
that.scenicData.polygons[i].longitude,
that.scenicData.polygons[i].latitude,
]);
}




let maipuLeLayerId;
switch (parseInt(that.hid)) {
case 18:
maipuLeLayerId = 53004;
break;
case 17:
maipuLeLayerId = 4249;
break;
}
that.leLayer = new AMap.TileLayer({

tileUrl:



"https://tiles.worldmaipu.com/" + maipuLeLayerId + "/[z]/[x]_[y].png",
zIndex: 2,
});
that.leLayer.setMap(that.scenicMapObj);


that.isLocation = true; 
that.scenicMapObj.on("complete", function () {
console.log("地图加载完毕");
});


for (let j in that.poiType) {
if (that.poiType[j].isHasPoi) {
that.activePoiTypeId = that.poiType[j].id;

break;
}
}
console.log(that.poiType[that.activePoiTypeIndex]);
for (let z in that.poiType[that.activePoiTypeIndex].types) {
that.curMarkers = that.curMarkers.concat(
that.poiType[that.activePoiTypeIndex].types[z].markerArr[
that.scenicMapObj.getZoom() - that.mapMinZoom
]
);
console.log(that.curMarkers);
}
console.log(that.curMarkers);
if (that.curMarkers == undefined || that.curMarkers.length == 0) {
} else {
that.scenicMapObj.add(that.curMarkers);






}



AMap.event.addListener(that.scenicMapObj, "zoomend", function () {
console.log("当前地图层级==" + that.scenicMapObj.getZoom());
that.mapMoveEnd();
});


AMap.event.addListener(that.scenicMapObj, "click", function (e) {
console.log("点击地图");
console.log(e.lnglat);
});


that.scenicMapObj.plugin(["AMap.ToolBar"], function () {
that.scenicMapObj.addControl(
new AMap.ToolBar({
position: "LB",

liteStyle: true,
offset: new AMap.Pixel(10, 200),
})
);
});
},

setPoiType(arr) {
let that = this;
for (let i in arr) {
let obj = {};
obj.id = arr[i].typeId;
obj.name = arr[i].typeName;
obj.icon = that.GLOBAL.DOMAIN_URL + arr[i].icon;
obj.picth_icon = that.GLOBAL.DOMAIN_URL + arr[i].picthIcon;


obj.types = [];
for (let j in arr[i].navItems) {
let sortObj = {};
sortObj.pointIcon =
that.GLOBAL.DOMAIN_URL + arr[i].navItems[j].pointIcon;
sortObj.id = arr[i].navItems[j].typeId;
sortObj.pointPicthIcon =
that.GLOBAL.DOMAIN_URL + arr[i].navItems[j].pointPicthIcon;
sortObj.markerArr = [];
sortObj.typeName = arr[i].navItems[j].typeName;
for (let z = that.mapMinZoom; z <= that.mapMaxZoom; z++) {
sortObj.markerArr.push([]);
}
obj.types.push(sortObj);
}
obj.isHasPoi = false; 
that.poiType.push(obj);
}
}, // 处理生成poi点 isScenicPoi是否是景点
openLayer() {
if (this.isleLayerShow == false) {
this.leLayer.setMap(this.scenicMapObj);
} else {
this.scenicMapObj.remove(this.leLayer);
}
this.isleLayerShow = !this.isleLayerShow;
},

setPois(pointses) {
let that = this;

let poiZoomRange = that.mapMaxZoom - that.mapMinZoom;
for (let i in pointses) {

let max_zoom = pointses[i].max_zoom;

let min_zoom = pointses[i].min_zoom;
let icon_default; 
let typeIndex; 
let typeIdx; 
let isHasThisType = false; 
for (let j in that.poiType) {
for (let z in that.poiType[j].types) {
if (pointses[i].type == that.poiType[j].types[z].id) {
icon_default = that.poiType[j].types[z].pointIcon;

typeIndex = j;
typeIdx = z;
isHasThisType = true;
that.poiType[j].isHasPoi = true; 
break;
}
}
}

if (!isHasThisType) {
continue;
}
let marker = new AMap.Marker({
position: new AMap.LngLat(
pointses[i].longitude,
pointses[i].latitude
),
content:
"<div class='poi' id='poi" +
i +
"'><img class='iconall icon-default' src='" +
icon_default +
"'><span class='poiName'>" +
pointses[i].chs_name +
"</span></div>",
offset: new AMap.Pixel(-23, -46),
extData: {
poiData: pointses[i],
},
});
AMap.event.addListener(marker, "click", function (e) {
this.setTop(true);

that.poiMarkerFun(this);
});
let min = pointses[i].min_zoom - that.mapMinZoom;
for (let z = 0; z < poiZoomRange + 1; z++) {
if (z >= min) {
that.poiType[typeIndex].types[typeIdx].markerArr[z].push(marker);
}
}
}
},

creatMarker(point) {
let that = this;
let className;
let offset = new AMap.Pixel(-16, -32);
switch (Number(point.type)) {
case 2:
className = "talk";




offset = new AMap.Pixel(-16, -16);
break;
case 9:
className = "parking";
break;
case 6:
className = "toilet";
break;
case 8:
className = "cate";
break;
case 5:
className = "hotel";
break;
case 12:
className = "shopping";
break;
case 10:
className = "service";
break;
}
let thisPoi = new AMap.Marker({
content:
"<div class='poi'><div class='" +
className +
" iconall'></div><span class='poiName'>" +
point.chs_name +
"</span></div>",
position: new AMap.LngLat(point.longitude, point.latitude),

offset: offset,
extData: {
poiData: point,
},
});
return thisPoi;
},
poiMarkerFun(_this) {
let that = this;
let position = _this.getPosition();
let extData = _this.getExtData();
console.log(extData);

if (that.activePoiTypeId == 1) {
that.activeScenicPoiData = extData.poiData;
that.playing = false;

if (extData.poiData.audio != null) {
that.myAudioSrc =
that.GLOBAL.DOMAIN_URL +
extData.poiData.audio.split(".")[0] +
".mp3";
} else {
that.myAudioSrc = null;
}

if (that.myAudioSrc != null) {
document.getElementById("myAudio").load();
}
} else {

console.log(
"poiMarkerFun -> extData.chs_name",
extData.poiData.chs_name
);
console.log("poiMarkerFun -> " + sessionStorage.getItem("lat"));
console.log("poiMarkerFun -> " + sessionStorage.getItem("lng"));
console.log(
"poiMarkerFun -> extData.latitude",
extData.poiData.latitude
);
console.log(
"poiMarkerFun -> extData.longitude",
extData.poiData.longitude
);
that.nav(
extData.poiData.chs_name,
extData.poiData.latitude,
extData.poiData.longitude
);
}
},

setLine(linesList) {
let that = this;
for (let i in linesList) {
let obj = {};
obj.lineName = linesList[i].lineName;
obj.lineDuration = linesList[i].reserved3;
obj.lineSpots = linesList[i].reserved4;
obj.id = linesList[i].id;
obj.coordinateList = [];
obj.linePois = [];
obj.lineMarkers = [];
let z = 1;
for (let n in linesList[i].coordinateList) {
obj.linePois.push(
new AMap.LngLat(
Number(linesList[i].coordinateList[n].longitude),
Number(linesList[i].coordinateList[n].latitude)
)
);
if (linesList[i].coordinateList[n].reserved1.indexOf("默认") == -1) {

obj.coordinateList.push(linesList[i].coordinateList[n]);
let marker = new AMap.Marker({
content:
"<div class='line-poi'><div class='line-marker' number='" +
n +
"'>" +
z +
"</div><span class='poiName'>" +
linesList[i].coordinateList[n].reserved1 +
"</span></div>",
position: new AMap.LngLat(
linesList[i].coordinateList[n].longitude,
linesList[i].coordinateList[n].latitude
),

offset: new AMap.Pixel(-23, -46),
extData: {
poiData: linesList[i].coordinateList[n],
index: z - 1,
},
});
AMap.event.addListener(marker, "click", function (e) {
let thisPosition = e.target.getPosition();
let extData = e.target.getExtData().poiData;
let index = e.target.getExtData().index;
that.linePoiClick(thisPosition, extData, index);
that.activeLineSpotIdx = index;
that.swiperItemIndex = parseInt(index) + 1;

});

obj.lineMarkers.push(marker);
z++;
}
}
that.lines.push(obj); 
}
console.log(that.lines);










},

linePoiClick(thisPosition, extData) {
console.log(extData);
this.playing = false;
if (extData.audio != null) {
this.myAudioSrc =
this.GLOBAL.DOMAIN_URL + extData.audio.split(".")[0] + ".mp3";
} else {
this.myAudioSrc = null;
}

if (this.myAudioSrc != null) {
document.getElementById("myAudio").load();
}






this.scenicMapObj.setCenter(thisPosition);
},

lineTrigger() {
if (this.isLineListShow) {

this.isLineListShow = false;
this.activeLineIdx = -1;
if (this.isInLine) {
if (!document.getElementById("myAudio").paused) {
document.getElementById("myAudio").pause();
this.playing = false;
}
this.isInLine = false;
this.scenicMapObj.remove(this.polyline);
this.mapMoveEnd();
}
} else {

this.isLineListShow = true;
}
},

showLine(i) {
this.activeLineIdx = i;
console.log(i);
this.scenicMapObj.remove(this.curMarkers);

this.activeScenicPoiData = null;
if (!document.getElementById("myAudio").paused) {
this.playing = false;
this.myAudioSrc = null;
document.getElementById("myAudio").pause();
}

if (this.polyline == null) {
} else {
this.scenicMapObj.remove(this.polyline);
}
this.polyline = new AMap.Polyline({
path: this.lines[i].linePois, //设置线覆盖物路径
strokeColor: "#f56b61", //线颜色
strokeOpacity: 0.8, //线透明度
strokeWeight: 3, //线宽
strokeStyle: "solid", //线样式
isOutline: true,
borderWeight: 1,
outlineColor: "#fff",
lineJoin: "round",
lineCap: "round",
strokeDasharray: [10, 5], //补充线样式
zIndex: 9999,
});
this.polyline.setMap(this.scenicMapObj);
this.curMarkers = this.lines[i].lineMarkers;
this.scenicMapObj.add(this.curMarkers);
this.isInLine = true;
this.scenicMapObj.setFitView(this.curMarkers);
this.activeLineSpotIdx = -1;
this.swiperItemIndex = 0;
},

mapMoveEnd() {
if (this.isInLine) {

return;
} else {

this.addPoi();
}
},

addPoi() {
console.log("addPoi");
this.scenicMapObj.remove(this.curMarkers);
this.curMarkers = [];








let zoom = this.scenicMapObj.getZoom();
























console.log(this.activePoiTypeId);
for (let z in this.poiType[this.activePoiTypeIndex].types) {
this.curMarkers = this.curMarkers.concat(
this.poiType[this.activePoiTypeIndex].types[z].markerArr[
this.scenicMapObj.getZoom() - this.mapMinZoom
]
);
}
console.log(this.curMarkers);
this.scenicMapObj.add(this.curMarkers);
},

changeMarkerType(i) {
this.activePoiTypeId = i;

if (this.isLineListShow) {

this.isLineListShow = false;
this.activeLineIdx = -1;
if (this.isInLine) {
this.isInLine = false;
this.scenicMapObj.remove(this.polyline);
}
}

this.activeScenicPoiData = null;
if (!document.getElementById("myAudio").paused) {
this.playing = false;
this.myAudioSrc = null;
document.getElementById("myAudio").pause();
}


this.addPoi();
},

showTalks() {
if (this.activePoiTypeId == 1) {
} else {
this.activePoiTypeId = 1;
this.addPoi();
}
this.isNearListShow = false;
},

playScenicAudio() {
let that = this;
let audio = document.getElementById("myAudio");
if (this.myAudioSrc == null) {
this.$vux.toast.text("暂无音频", "bottom");
} else {
if (audio.paused) {
audio.play();
audio.addEventListener("ended", function () {
that.playing = false;
});
this.playing = true;
} else {
audio.pause();
this.playing = false;
}
}
},

nav(name, lat, lng) {
this.commonFun.openLocation(
name,
sessionStorage.getItem("lat"),
sessionStorage.getItem("lng"),
lat,
lng
);
},
onSwiperItemIndexChange(index) {
console.log("demo item change", index);
if (index != 0) {
this.activeLineSpotIdx = index - 1;
this.linePoiClick(
this.lines[this.activeLineIdx].lineMarkers[
this.activeLineSpotIdx
].getPosition(),
this.lines[this.activeLineIdx].lineMarkers[
this.activeLineSpotIdx
].getExtData().poiData
);
}
},



},

created() {},

mounted() {
this.getScenicData();
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {
if (this.$route.query.hid != this.hid) {
console.log("🚀 ~ file: Scenic.vue ~ line 880 ~ activated ~ activated");
Object.assign(this.$data, this.$options.data.call(this));
this.hid = this.$route.query.hid;
this.$nextTick(function () {
this.getScenicData();
});
}
}, //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/Scenic/Scenic.vue